import {
  Col,
  ExclamationIcon,
  IconButton,
  Row,
  ThreeDotsLoader,
} from 'plataforma-fundacao-componentes';
import React, { Fragment } from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';

import styles from './styles.module.scss';

interface Props {
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  label: React.ReactNode;
  value: string | number | React.ReactNode;
  onClick?: () => void;
  infoDescription?: () => void;
  button?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

export default function LabelValueCard({
  icon,
  badge,
  label,
  value,
  onClick,
  button,
  loading,
  disabled = false,
  infoDescription,
}: Props) {
  return (
    <Fragment>
      <Row
        className={clsx([
          styles.root,
          loading ? styles.button_disabled : '',
          button ? styles.button : '',
          disabled ? styles.disabled : '',
        ])}
        onClick={!loading && button ? onClick : undefined}
      >
        <Col className={styles.header}>
          <div>
            {infoDescription && !icon ? (
              <IconButton
                className={styles.infoIcon}
                icon={<ExclamationIcon />}
                onClick={infoDescription}
              />
            ) : undefined}
            {icon ? (
              <div style={{ position: 'relative' }}>
                <IconButton className={styles.infoIcon} icon={icon} />
                {badge ? <div className={styles.badge}></div> : null}
              </div>
            ) : undefined}
          </div>
          {loading ? (
            <div className={styles.loader}>
              <ThreeDotsLoader size={1} />
            </div>
          ) : (
            <p>{value}</p>
          )}
        </Col>
        <Col className={styles.footer} noPadding>
          <span>{label}</span>
        </Col>
      </Row>
    </Fragment>
  );
}
